"use strict";

window.App = window.App || {};

window.App.activityTrackerDrawer = {
	_timeline: null,
	_scrollEl: null,
	_loadMoreEl: null,
	_observer: null,
	_loading: false,
	_refreshing: false,

	init: function () {
		this._timeline = document.getElementById("kt_activity_timeline");
		this._scrollEl = document.getElementById("kt_activities_scroll");
		this._loadMoreEl = document.getElementById("kt_activity_tracker_load_more");

		if (!this._timeline || !this._scrollEl || !this._loadMoreEl) {
			return;
		}

		document.getElementById("kt_activities_toggle")?.addEventListener("click", function () {
			jQuery("#theActivityBadge").hide().text("");
		});

		if (typeof IntersectionObserver === "undefined") {
			this._scrollEl.addEventListener("scroll", this._onScrollFallback.bind(this));
			return;
		}

		this._observer = new IntersectionObserver(this._onLoadMoreVisible.bind(this), {
			root: this._scrollEl,
			rootMargin: "0px 0px 80px 0px",
			threshold: 0,
		});

		if (this._hasMore()) {
			this._observer.observe(this._loadMoreEl);
		}
	},

	_onScrollFallback: function () {
		if (this._loading || !this._hasMore()) {
			return;
		}

		var remaining = this._scrollEl.scrollHeight - (this._scrollEl.scrollTop + this._scrollEl.clientHeight);
		if (remaining > 120) {
			return;
		}

		this._fetchNextPage();
	},

	_onLoadMoreVisible: function (entries) {
		if (!entries.length || !entries[0].isIntersecting) {
			return;
		}

		if (this._loading || !this._hasMore()) {
			return;
		}

		this._fetchNextPage();
	},

	_hasMore: function () {
		return this._timeline && this._timeline.dataset.trackerHasMore === "1";
	},

	_setLoading: function (isLoading) {
		this._loading = isLoading;

		if (this._loadMoreEl) {
			this._loadMoreEl.classList.toggle("is-loading", isLoading);
		}
	},

	_updateLoadMore: function () {
		if (!this._loadMoreEl) {
			return;
		}

		if (this._hasMore()) {
			this._loadMoreEl.classList.remove("d-none");
			this._observer?.observe(this._loadMoreEl);
		} else {
			this._loadMoreEl.classList.add("d-none");
			this._observer?.unobserve(this._loadMoreEl);
		}
	},

	received: function () {
		this._incrementBadge(1);
		this._refreshLatest(false);
	},

	poll: function () {
		this._refreshLatest(true);
	},

	_incrementBadge: function (amount) {
		var badge = jQuery("#theActivityBadge");
		var currentText = badge.text().trim();
		var currentCount = currentText === "99+" ? 99 : parseInt(currentText, 10) || 0;
		var nextCount = currentCount + amount;

		badge.text(nextCount > 99 ? "99+" : nextCount).show();
	},

	_refreshLatest: function (countNewItems) {
		var self = this;

		if (this._refreshing || !this._timeline) {
			return;
		}

		this._refreshing = true;

		jQuery.ajax({
			type: "GET",
			url: "/activity/tracker/refresh",
			dataType: "json",
			success: function (response) {
				var responseContainer = document.createElement("div");
				responseContainer.innerHTML = response.html || "";

				var existingIds = {};
				self._timeline.querySelectorAll("[data-activity-id]").forEach(function (item) {
					existingIds[item.dataset.activityId] = true;
				});

				var newItems = Array.from(responseContainer.querySelectorAll("[data-activity-id]"))
					.filter(function (item) {
						return !existingIds[item.dataset.activityId];
					});

				if (countNewItems && newItems.length > 0) {
					self._incrementBadge(newItems.length);
				}

				if (newItems.length === 0) {
					return;
				}

				self._timeline.querySelector(".text-center.py-10")?.remove();
				self._timeline.insertAdjacentHTML(
					"afterbegin",
					newItems.map(function (item) {
						return item.outerHTML;
					}).join("")
				);

				var mode = self._timeline.dataset.trackerMode || "all";
				if (mode === "all" || mode === "recent") {
					var offset = parseInt(self._timeline.dataset.trackerOffset || "0", 10);
					self._timeline.dataset.trackerOffset = String(offset + newItems.length);
				}

				window.KTMenu?.createInstances?.();
			},
			complete: function () {
				self._refreshing = false;
			},
		});
	},

	_fetchNextPage: function () {
		var self = this;
		var mode = this._timeline.dataset.trackerMode || "all";
		var offset = this._timeline.dataset.trackerOffset || "0";

		this._setLoading(true);

		jQuery.ajax({
			type: "GET",
			url: "/activity/tracker",
			dataType: "json",
			data: {
				mode: mode,
				offset: offset,
			},
			success: function (response) {
				if (response.html) {
					self._timeline.insertAdjacentHTML("beforeend", response.html);
				}

				self._timeline.dataset.trackerMode = response.mode || mode;
				self._timeline.dataset.trackerOffset = String(response.nextOffset ?? offset);
				self._timeline.dataset.trackerHasMore = response.hasMore ? "1" : "0";

				self._updateLoadMore();
				window.KTMenu?.createInstances?.();
			},
			error: function () {
				self._timeline.dataset.trackerHasMore = "0";
				self._updateLoadMore();
			},
			complete: function () {
				self._setLoading(false);
			},
		});
	},
};

jQuery(function () {
	window.App.activityTrackerDrawer.init();
});
